<template>
  <p class="cardTags">
    <slot />
  </p>
</template>

<style lang="sass">
.cardTags
  font-weight: bold
  > *
    display: inline-flex
    margin: 0 0.25rem
    &:not(:last-child)
      &::after
        content: ', '
</style>
